import React, { useEffect, useState } from 'react'
import DoctorForm from '../DoctorForm'
import DoctorScan from '../../../DoctorScan'
import classes from './FormPage.module.scss'
import { toast } from 'react-toastify'
import {useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux'
import PreScannedPage from '../../../PreScannedPage'

const FormPage = () => {
    const navigate = useNavigate()
    const [scaned, setScaned] = useState(false)
    const [checked, setChecked] = useState(false)
    const [input , setInput] = useState({
        "id": "",
        "status": "",
        "research": ""
    })
    const id = useSelector(state=>state.RegScan.ScanInputs.id)


    useEffect(()=>{
        if (input.status == 'toDoctor'){
            setScaned(true)
        } else if(input.status == 'finished' && input.type === "change") {
            setScaned(true)
        } else if (input.status == 'finished'){
            toast.error('Висновок вже сформовано!!')
            navigate(`/PatientCard/${input.id}`)
        } else if (input.status == 'scanAfterForm' || input.status == 'registered' || input.status =='scanBeforePaint' || input.status == 'scanAfterPaint') {
            toast.error('Дослідження ще не завершено!')
        }
    },[input])

    const CheckedHabdler = () =>{
        setChecked(true)
    }

    return (
        <div className={classes.container}>
            {scaned && checked && <DoctorForm formFinished={setScaned} type={input}/>}
            {!scaned && <DoctorScan onChange={setInput}/>}
            {scaned && !checked && <PreScannedPage onClose={CheckedHabdler} input={id}/>}
        </div>
    )
}

export default FormPage